export var convertSyncBlockPMNodeToSyncBlockData = function convertSyncBlockPMNodeToSyncBlockData(node) {
  return {
    blockInstanceId: node.attrs.localId,
    content: node.content.toJSON(),
    resourceId: node.attrs.resourceId
  };
};
export var isBlogPageType = function isBlogPageType(pageType) {
  return pageType === 'blogpost';
};